module.exports = __webpack_public_path__ + "img/ilustracion-404.2752c191.svg";